(function (){
    'use strict';

    angular
        .module('payroll', []);
})();